import { WarningCircle } from "@phosphor-icons/react";
import "./SystemContentDisclaimer.css";

/**
 * Small orange notice shown wherever a CliniKit built-in form / template /
 * questionnaire is displayed. Clarifies that the content is a starting point
 * and carries no professional or legal warranty.
 */
const SystemContentDisclaimer = ({ kind = "form", compact = false }) => {
  const noun = kind === "template" ? "התבנית" : kind === "questionnaire" ? "השאלון" : "הטופס";
  return (
    <div className={`ck-sys-disclaimer${compact ? " is-compact" : ""}`} role="note">
      <WarningCircle size={16} weight="fill" className="ck-sys-disclaimer-icon" />
      <p>
        <strong>לתשומת לבך:</strong> {noun} מסופק/ת על ידי CliniKit כנקודת פתיחה בלבד. מומלץ להתאים את התוכן
        לצרכי הקליניקה ולהיוועץ בגורם מקצועי או משפטי לפני השימוש. CliniKit אינה נושאת באחריות לתוכן,
        לדיוקו או לתוקפו המשפטי.
      </p>
    </div>
  );
};

export default SystemContentDisclaimer;
